import { lazy, Suspense } from "react";
import Header from "@/components/marketing/Header";
import Hero from "@/components/marketing/Hero";
import ClientShowcase from "@/components/marketing/ClientShowcase";
import PricingCards from "@/components/marketing/PricingCards";
import SEO from "@/components/marketing/SEO";
import StickySignupBar from "@/components/marketing/StickySignupBar";
import ExitIntentPopup from "@/components/marketing/ExitIntentPopup";
import { faqData } from "@/components/marketing/FAQ";

const HowItWorks = lazy(() => import("@/components/marketing/HowItWorks"));
const FeaturesAccordion = lazy(() => import("@/components/marketing/FeaturesAccordion"));
const CustomerExperience = lazy(() => import("@/components/marketing/CustomerExperience"));
const Positioning = lazy(() => import("@/components/marketing/Positioning"));
const LocalSection = lazy(() => import("@/components/marketing/LocalSection"));


const Guarantees = lazy(() => import("@/components/marketing/Guarantees"));
const FAQ = lazy(() => import("@/components/marketing/FAQ"));
const FinalCTA = lazy(() => import("@/components/marketing/FinalCTA"));
const Footer = lazy(() => import("@/components/marketing/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Piktable · L'outil de réservation des restaurateurs suisses"
        description="Piktable est l'outil de gestion de réservations conçu pour les restaurateurs suisses. Tout inclus, sans commission par couvert. 30 jours gratuits."
        canonical="/"
        structuredData={[
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqData.map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Piktable",
            "legalName": "Reversed Sàrl",
            "url": "https://piktable.ch",
            "logo": "https://piktable.ch/favicon.png",
            "description": "L'outil de réservation pensé à Lausanne pour les cafés, bistrots et restaurants de Suisse romande. Sans commission par couvert.",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Lausanne",
              "addressRegion": "VD",
              "addressCountry": "CH"
            },
            "contactPoint": [
              {
                "@type": "ContactPoint",
                "contactType": "customer support",
                "email": "contact@piktable.ch",
                "availableLanguage": ["French"],
                "areaServed": "CH"
              },
              {
                "@type": "ContactPoint",
                "contactType": "sales",
                "email": "maxime@piktable.ch",
                "availableLanguage": ["French"],
                "areaServed": "CH"
              }
            ],
            "sameAs": [
              "https://www.instagram.com/piktable"
            ]
          },
          {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Piktable",
            "applicationCategory": "BusinessApplication",
            "operatingSystem": "Web",
            "description": "Logiciel SaaS de gestion de réservations pour restaurants en Suisse, sans commission par couvert.",
            "url": "https://piktable.ch",
            "offers": {
              "@type": "AggregateOffer",
              "lowPrice": "29",
              "highPrice": "49",
              "priceCurrency": "CHF",
              "offerCount": "2"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5.0",
              "reviewCount": "3",
              "bestRating": "5",
              "worstRating": "1"
            },
            "provider": {
              "@type": "Organization",
              "name": "Piktable",
              "url": "https://piktable.ch"
            }
          }
        ]}
      />
      <Header />
      <main>
        <Hero />
        <ClientShowcase />
        <PricingCards
          heading="L'offre à saisir maintenant"
          subheading="Réservée aux 50 premiers restaurants. Verrouillée à vie. Commence par 60 jours gratuits."
        />
        <Suspense fallback={<div className="min-h-[400px]" />}>
          <FeaturesAccordion />
          <HowItWorks />
          <CustomerExperience />
          <Positioning />
          <LocalSection />
          <Guarantees />
          <FAQ />
          <FinalCTA />
        </Suspense>
      </main>
      <Footer />
      <StickySignupBar />
      <ExitIntentPopup />
    </div>
  );
};

export default Index;
